import { render, staticRenderFns } from "./ApprovalKeringanan.vue?vue&type=template&id=4e0cba03&"
import script from "./ApprovalKeringanan.vue?vue&type=script&lang=js&"
export * from "./ApprovalKeringanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports